import { render, staticRenderFns } from "./Dentist.vue?vue&type=template&id=dbd53b26&"
import script from "./Dentist.vue?vue&type=script&lang=js&"
export * from "./Dentist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports